import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { MOMENT_FORMATS } from 'src/consumer/constants'
dayjs.extend(utc)

export default function HistoryComponent({ bookedEventInfo, clinicBrand }) {
  console.log({ clinicBrand })

  return (
    <div className="w-100 h-100">
      {bookedEventInfo?.modificationHistory && bookedEventInfo?.modificationHistory?.length > 0 ? (
        <>
          <h5 className="mt-3 mb-2">Modification History</h5>
          {bookedEventInfo?.modificationHistory?.map((history, idx) => {
            return (
              <div key={idx}>
                <div>
                  Appointment Number Before Modification:{' '}
                  {history?.appointmentNumberBeforeModification}
                </div>
                <div>Event: {history?.event}</div>
                <div>
                  Start Time before Modification:{' '}
                  {dayjs
                    .utc(history?.startTimeBeforeModification)
                    .local()
                    .format(MOMENT_FORMATS.completeTimeDetails)}
                </div>
                <div>
                  Modified At:{' '}
                  {dayjs
                    .utc(history?.modifiedAt)
                    .local()
                    .format(MOMENT_FORMATS.completeTimeDetails)}
                </div>
                <hr></hr>
              </div>
            )
          })}
        </>
      ) : (
        <strong className="mt-3 mb-2">No Modification History</strong>
      )}
    </div>
  )
}
